import _ from 'lodash';

const betaList = [1, 5, 17, 18, 19, 20, 6, 10, 13, 7, 9, 14, 11, 12, 21, 15];

export default {
  namespaced: true,
  state: {
    currentSeason: undefined,
    meta: {
      endOfYear: undefined,
      timezone: undefined,
      primaryColor: undefined,
      secondaryColor: undefined,
      imgUrl: undefined,
      multipleRegoAllowed: false,
    },
    misc: {
      deregistrationEnabled: true,
    },
    entity: {
      _id: undefined,
      level: undefined,
      name: undefined,
    },
    module: {
      appointment: false,
      timezone: undefined,
    },
    paymentPreference: {},
    mode: 'beta',
    saleableItemTypes: [],
    memberTypes: [],
  },
  mutations: {
    updateMeta(state, payload) {
      state.meta = _.merge(state.meta, payload.meta);
    },
    updateMisc(state, payload) {
      console.log('updateMisc', payload);
      state.misc = _.merge(state.misc, payload.misc);
      console.log('state.misc', state.misc);
    },
    updateModule(state, payload) {
      state.module = _.merge(state.module, payload.module);
    },
    updateCurrentSeason(state, payload) {
      state.currentSeason = payload.currentSeason;
    },
    updateSaleableItems(state, payload) {
      state.saleableItemTypes = payload.saleableItemTypes;
    },
    updateMemberTypes(state, payload) {
      state.memberTypes = payload.memberTypes;
    },
    updatePaymentPref(state, payload) {
      state.paymentPreference = payload.paymentPreference;
    },
    clearPaymentPref(state) {
      state.paymentPreference = false;
    },
    setMeta(state, payload) {
      _.assign(state.meta, payload.meta);
      state.entity._id = payload._id;
    },
    setEntity(state, payload) {
      state.entity = payload.entity;
    },
    resetCustom(state) {
      // reset to default use assign instead of replacing the object
      _.assign(state.meta, {
        primaryColor: undefined,
        secondaryColor: undefined,
        imgUrl: undefined,
      });
      _.assign(state.entity, {
        _id: undefined,
        level: undefined,
        name: undefined,
      });
      document.documentElement.style.setProperty('--highlight-color', process.env.VUE_APP_HIGHLIGHT_COLOR);
      document.documentElement.style.setProperty('--secondary-color', process.env.VUE_APP_SECONDARY_COLOR);
    },
    switchMode(state) {
      // switch mode between beta and original
      state.mode = state.mode === 'beta' ? 'original' : 'beta';
    },
    setMode(state, payload) {
      state.mode = payload.mode;
    },
  },
  actions: {
    setInitialMode({ commit }) {
      const nationalId = +process.env.VUE_APP_NATIONAL_ID;
      // const betaNationalIds = [6, 10, 13, 7, 9, 14, 11];
      if (betaList.includes(nationalId)) {
        commit('setMode', { mode: 'beta' });
      }
    },
    async setup({ commit }) {
      const res = await this._vm.$http.get('assemble/api/v1/portal/nationals/get/meta');
      if (res.data.data) {
        commit('updateMeta', res.data.data);
        commit('updateMisc', res.data.data);
        commit('updateModule', res.data.data);
        commit('updateSaleableItems', res.data.data);
        commit('updateMemberTypes', res.data.data);
        commit('updateCurrentSeason', res.data.data);
      }

      // if ([6, 10, 13, 7, 9, 14, 11].includes(+process.env.VUE_APP_NATIONAL_ID)) {
      //   commit('national/setMode', { mode: 'beta' });
      // }

      const pref = await this._vm.$http.get('assemble/api/v1/portal/nationals/get/payment-preference');
      if (pref.data.data) commit('updatePaymentPref', pref.data.data);
    },
    async getSlugBranding({ commit }, slugs) {
      const resMetaSlug = await this._vm.$httpNoAuth.get('assemble/api/v1/portal/national/get/slug-details', // add the slug to the url
        {
          params: {
            slugs,
          },
        });
      if (resMetaSlug.data.data) {
        const { meta, _id, entityLevel } = resMetaSlug.data.data;
        if (meta && meta.primaryColor && meta.secondaryColor) {
          await commit('setMeta', { meta });
          await commit('setEntity', { entity: { _id, level: entityLevel, name: slugs.entityName } });
          document.documentElement.style.setProperty('--highlight-color', meta.primaryColor);
          document.documentElement.style.setProperty('--secondary-color', meta.secondaryColor);
        } else {
          await commit('setMeta', { meta });
          await commit('setEntity', { entity: { _id, level: entityLevel, name: slugs.entityName } });
          document.documentElement.style.setProperty('--highlight-color', process.env.VUE_APP_HIGHLIGHT_COLOR);
          document.documentElement.style.setProperty('--secondary-color', process.env.VUE_APP_SECONDARY_COLOR);
        }
      }
    }
  },
  getters: {
    memberTypes(state) {
      return _.get(state, 'memberTypes', []);
    },
    endOfYear(state) {
      return _.get(state, 'meta.endOfYear');
    },
    ageCalculation(state) {
      return _.get(state, 'meta.ageCalculation', { method: 'defaultEndOfYear', specificDate: null });
    },
    paymentPreference(state) {
      return _.get(state, 'paymentPreference', {});
    },
    timezone(state) {
      return _.get(state, 'meta.timezone', 'Australia/Sydney');
    },
    getMeta(state) {
      return state.meta;
    },
    getMisc(state) {
      return state.misc;
    },
    getEntity(state) {
      return state.entity;
    },
    getSaleableItemTypes(state) {
      return state.saleableItemTypes;
    },
    getMemberTypes(state) {
      return state.memberTypes;
    },
    getOrganisation(state) {
      return state.entity;
    },
    getLogo(state) {
      return _.get(state, 'meta.imgUrl');
    },
    module(state) {
      return _.get(state, 'module', {});
    },
    hasAppointmentModule(state) {
      return _.get(state, 'module.appointment', false);
    },
    getIsBetaMode(state) {
      return _.get(state, 'mode') === 'beta';
    },
    currentSeason(state) {
      return _.get(state, 'currentSeason');
    },
    getMultipleRegoAllowed(state) {
      return _.get(state, 'meta.multipleRegoAllowed');
    }
  },
};
